import React, { useState, useEffect } from "react";
import "./Home.css";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import aboUeducate from "../../Assests_Url/about ueducate.png";
import {
  getNcretBookDetails,
  getAllKatBookSubjects,
} from "../../Services/ApiService";
import student from "../../Assests_Url/student_kat.png";
import teacher from "../../Assests_Url/teacher_kat.png";
import { useLocation, useNavigate } from "react-router-dom";
import ueducate from "../../Assests_Url/Ueducate_Logo_New.jpg";
import CryptoJS from "crypto-js";

const Home = ({
  RoutesClick,
  NcertClick,
  selectedLang,
  setSelectedLang,
  subjectArr,
  setsubjectArr,
  allCountries
}) => {
  const [registerModal, setRegisterModal] = useState(false);
  const [activeTabHeader, setActiveTabHeader] = useState("Home");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);
  const [AdminregisterModal, setAdminregisterModal] = useState(false);

  let KatbookUrl = `https://view.ueducatetelangana.com`;
  // let KatbookUrl = `http://localhost:8000`;

  let userid = localStorage.getItem("userID");
  let userresidd, UserToken;
  let secretKey = "KampusNcrt";
  let Acckey = "KPOSTKatBooks#$*(@#)!!";
  if (localStorage.getItem("userID") && localStorage.getItem("token")) {
    const decrypteduserIDD = CryptoJS.AES.decrypt(userid, secretKey);
    userresidd = JSON.parse(decrypteduserIDD.toString(CryptoJS.enc.Utf8));
    UserToken = localStorage.getItem("token");
  }

  const getSubjectDetails = async (BookIDs) => {
    const encryptedSubjects = localStorage.getItem("encryptedSubjects");
    const decryptedSubjects = CryptoJS.AES.decrypt(
      encryptedSubjects,
      secretKey
    );
    const subjects = JSON.parse(decryptedSubjects.toString(CryptoJS.enc.Utf8));

    let allBooks;
    if (BookIDs) {
      allBooks = [
        ...BookIDs,
        "68c8081ac55d84a7149f2228",
        "68c808c8c55d84a7149f27d0",
      ];
    } else {
      allBooks = subjects.map((subject) => subject._id);
      allBooks = [
        ...allBooks,
        "68c8081ac55d84a7149f2228",
        "68c808c8c55d84a7149f27d0",
      ];
    }
    try {
      let bod = {
        bookIds: allBooks,
      };

      let res = await getAllKatBookSubjects(bod);
      if (res?.success === true) {
        setsubjectArr(res.units);
      } else {
        console.log(res.error, res, "testtstst");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(null);
  const [currentPage, setCurrentPage] = useState({}); // for slider

  const [tabs, setTabs] = useState([]);
  const [allBooks, setallBooks] = useState([]);
  console.log(tabs, "123");

  const getBookData = async () => {
    try {
      let res = await getNcretBookDetails();
      if (res?.success && res?.data?.length > 0) {
        const allowedClasses = ["Class 6", "Class 7", "Class 8"];
        const allowedLanguages = ["english"];
        setallBooks(res?.data);
        let data = res?.data
          .filter((std) => {
            const isAllowedClass = allowedClasses.includes(std.standardName);
            const isAllowedLang = allowedLanguages.includes(std.bookLanguage);

            if (
              std.standardName === "Class 6" &&
              std.bookName === "हिंदी - मल्हार"
            )
              return false;

            if (
              std.standardName === "Class 12" &&
              std.bookName === "Mathematics"
            )
              return false;

            return isAllowedClass && isAllowedLang;
          })
          .sort(
            (a, b) =>
              allowedClasses.indexOf(a.standardName) -
              allowedClasses.indexOf(b.standardName)
          )
          .map((std) => ({
            label: std.standardName,
            value: std.standardId,
            bookName: std.bookName,
            bookId: std?.yearId,
            coverImage: std.coverImage,
            crumb: std.crumb,
            url: std.url,
            bookLanguage: std.bookLanguage,
          }));
        setTabs(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const classMap = {
    "6": "Class 6",
    "7": "Class 7",
    "8": "Class 8",
    "9": "Class 9",
    "10": "Class 10",
  };

  const uniqueTabs = [...new Set(tabs.map((t) => t.label))];
  const filteredBooks = tabs.filter((book) => book.label === activeTab);

  const booksPerPage = 4;
  // const totalPages =
  //   filteredBooks.length > booksPerPage ? 2 : 1; // 1 or 2 pages only
  const totalPages = Math.ceil(filteredBooks.length / booksPerPage);

  const showArrows = filteredBooks.length > booksPerPage;
  const currentPageForActiveTab = currentPage[activeTab] || 0;

  let currentBooks = [];
  if (totalPages === 1) {
    currentBooks = filteredBooks; // 4 or less books
  } else {
    if (currentPageForActiveTab === 0) {
      currentBooks = filteredBooks.slice(0, booksPerPage); // first 4
    } else {
      currentBooks = filteredBooks.slice(-booksPerPage); // last 4
    }
  }

  console.log(currentBooks, "currentBookscurrentBooks");
  const handlePrevClick = () => {
    if (activeTab) {
      setCurrentPage((prev) => ({
        ...prev,
        [activeTab]: Math.max((prev[activeTab] || 0) - 1, 0),
      }));
    }
  };

  const handleNextClick = () => {
    if (activeTab) {
      setCurrentPage((prev) => ({
        ...prev,
        [activeTab]: Math.min((prev[activeTab] || 0) + 1, totalPages - 1),
      }));
    }
  };

  const handleTabClick = (label) => {
    setActiveTab(label);
    // Reset to first page when switching tabs
    setCurrentPage((prev) => ({
      ...prev,
      [label]: 0,
    }));
  };

  useEffect(() => {
    if (uniqueTabs.length > 0 && !activeTab) {
      const initialTab = uniqueTabs[0];
      setActiveTab(initialTab);
      setCurrentPage({ [initialTab]: 0 });
    }
  }, [uniqueTabs, activeTab]);

  useEffect(() => {
    getBookData();
    if (
      localStorage.getItem("encryptedSubjects") &&
      localStorage.getItem("token")
    ) {
      getSubjectDetails();
    }
  }, []);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const lang = searchParams.get("lang") || "en";

  return (
    <div>
      <Header
        activeTab={activeTabHeader}
        handleTabClick={handleTabClickHeader}
        studentregisterModal={studentregisterModal}
        setStudentRegisterModal={setStudentRegisterModal}
        ParentregisterModal={ParentregisterModal}
        setParentRegisterModal={setParentRegisterModal}
        TeacherregisterModal={TeacherregisterModal}
        setTeacherregisterModal={setTeacherregisterModal}
        AdminregisterModal={AdminregisterModal}
        setAdminregisterModal={setAdminregisterModal}
        registerModal={registerModal}
        setRegisterModal={setRegisterModal}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
        selectedLang={selectedLang}
        setSelectedLang={setSelectedLang}
        allCountries={allCountries}
      />
      <div>
        <div>
          {/* <MediaQuery minWidth={700}> */}
          <div className="w-100">
            <div className="newHomeBanner">
              <div className="bannerOverlay">
                <div className="homeban">
                  <div className="d-flex flex-column align-items-center">
                    {lang === "en" ? (
                      <div className="homeBan1">
                        <span className="homeban2">Introducing</span>
                        <span className="homeban3">KATBOOKS</span>
                      </div>
                    ) : lang === "hi" ? (
                      <div className="homeBan1">
                        <span className="homeban3">KATBOOKS</span>
                        <span className="homeban2"> का परिचय</span>
                      </div>
                    ) : null}
                    <div className="homeban1_2">
                      {lang === "en"
                        ? "World’s most advanced and interactive format of digital books"
                        : lang === "hi"
                          ? "डिजिटल पुस्तकों का विश्व का सबसे उन्नत और इंटरैक्टिव प्रारूप"
                          : null}
                    </div>

                    <div className="homebanNCERT">
                      <span className="homebanNCERT1">
                        {lang === "en"
                          ? "Pilot Project in association with Telangana State Board"
                          : lang === "hi"
                            ? "एनसीईआरटी के सहयोग से पायलट प्रोजेक्ट"
                            : null}
                      </span>
                    </div>
                    <div className="homebanBooks mt-2">
                      {lang === "en"
                        ? "Telangana State Board books are now available in KATBOOK format for classes 6 to 10 (for all subjects)"
                        : lang === "hi"
                          ? "एनसीईआरटी की पुस्तकें अब कक्षा 1, 6 और 12 (सभी विषयों के लिए) के लिए कैटबुक प्रारूप में उपलब्ध हैं"
                          : null}
                    </div>
                    {!localStorage.getItem("token") && (
                      <button
                        className="registerBtn mt-4"
                        onClick={() => {
                          setRegisterModal(!registerModal);
                        }}
                      >
                        {lang === "en"
                          ? "Register now"
                          : lang === "hi"
                            ? "अभी पंजीकरण करें"
                            : null}{" "}
                        &nbsp; &rarr;
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* </MediaQuery> */}
        </div>

        <div className="secondPotionHome">
          <div className="container">
            <div className="row align-items-start h-100 d-flex justify-content-center align-items-center pad4per">
              {/* Left side - Image */}
              <div className="col-md-6 mb-4 mb-md-0 d-flex justify-content-center">
                <img
                  src="https://cdn.katbook.com/assets/sites/ncert/754664531329945600_aboutKatbook.png"
                  className="width_mob aboutKatt"
                  alt="Katbook Device Screenshot"
                />
              </div>

              {/* Right side - Content */}
              <div className="col-md-6 d-flex flex-column justify-content-center">
                {lang === "en" ? (
                  <div className="hsFonnt hsmobipad1">
                    <span className="hsFonnt1">KATBOOK </span>is
                    next-generation{" "}
                    <span className="hsFonnt2">digital textbook platform</span>,
                    developed with UEducate to transform the way India learns.
                    It blends{" "}
                    <span className="hsFonnt2">
                      audio, video, 2D/3D/AR/VR models, interactive exercises,
                      translation tools, smart search, personalization, and
                      analytics
                    </span>{" "}
                    into one seamless experience.
                  </div>
                ) : lang === "hi" ? (
                  <div className="hsFonnt hsmobipad1">
                    <span className="hsFonnt1">KATBOOK </span>एनसीईआरटी का अगली
                    जनरेशन का{" "}
                    <span className="hsFonnt2">
                      डिजिटल पाठ्यपुस्तक प्लैटफ़ॉर्म है
                    </span>
                    , जिसे भारत में सीखने के तरीके को बदलने के लिए यूएजुकेट के
                    साथ विकसित किया गया है। यह &nbsp;
                    <span className="hsFonnt2">
                      ऑडियो, वीडियो, 2D/3D/AR/VR मॉडल, इंटरैक्टिव अभ्यास, अनुवाद
                      उपकरण, स्मार्ट खोज, निजीकरण और विश्लेषण
                    </span>{" "}
                    को एक सहज अनुभव में मिश्रित करता है।
                  </div>
                ) : null}

                <div className="hsFonnt pt-3 hsmobipad1">
                  {/* Unlike static e-books, KATBOOK offers two tailored experiences
                  —{" "} */}
                  {lang === "en"
                    ? "Unlike static e-books, KATBOOK offers two tailored experiences —"
                    : lang === "hi"
                      ? "स्थिर ई-पुस्तकों के असमान, कैटबुक दो अनुकूलित अनुभव प्रदान करता है —"
                      : null}
                  <span className="hsFonnt2">
                    {/* for Foundation learners (Classes 1–5) */}
                    {lang === "en"
                      ? "for Foundation learners (Classes 1–5)"
                      : lang === "hi"
                        ? "फाउंडेशन शिक्षार्थियों (कक्षा 1-5)"
                        : null}
                  </span>{" "}
                  {/* and */}
                  {lang === "en" ? "and" : lang === "hi" ? "और" : null}
                  <span className="hsFonnt2">
                    {/* Higher Standard learners (Classes 6–12) */}
                    {lang === "en"
                      ? "Higher Standard learners (Classes 6–12)"
                      : lang === "hi"
                        ? " उच्च मानक शिक्षार्थियों (कक्षा 6-12) के लिए "
                        : null}
                  </span>{" "}
                  {/* —ensuring every stage of education is supported with the right
                  tools. */}
                  {lang === "en"
                    ? "—ensuring every stage of education is supported with the right tools."
                    : lang === "hi"
                      ? "- यह सुनिश्चित करते हुए कि शिक्षा के प्रत्येक चरण को सही उपकरणों के साथ समर्थित किया जाता है।"
                      : null}
                </div>

                <div className="regMobie">
                  <button
                    className="registerBtn mt-4"
                    onClick={() => {
                      navigate("/katbook");
                    }}
                  >
                    {/* Read More &nbsp; &rarr; */}
                    {lang === "en" ? (
                      <>Read More &nbsp; &rarr;</>
                    ) : lang === "hi" ? (
                      <>और पढ़ें &nbsp; &rarr;</>
                    ) : null}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column justify-content-center align-items-center gap-4 pt-2 pb-4 px-4">
          <div className="compe-font">
            {/* Why KATBOOK ? */}
            {lang === "en"
              ? "Why KATBOOK ?"
              : lang === "hi"
                ? "क्यों KATBOOK ?"
                : null}
          </div>
          <div className="kat-card">
            <div className="p-3 d-flex flex-column align-items-center gap-3 box-katbook">
              <div className="box-font">
                {/* For Students */}
                {lang === "en"
                  ? "For Students"
                  : lang === "hi"
                    ? "विद्यार्थियों के लिए"
                    : null}
              </div>
              <div>
                <img src={student} alt="" width={"85%"} />
              </div>
              <div className="box-para-font text-center">
                {/* It makes learning joyful, interactive, and self-paced                 */}
                {lang === "en"
                  ? "It makes learning joyful, interactive, and self-paced"
                  : lang === "hi"
                    ? "यह सीखने को आनंददायक, संवादात्मक और स्व-गति आधारित बनाता है।"
                    : null}
              </div>
            </div>

            <div className="p-3 d-flex flex-column align-items-center gap-3 box-katbook">
              <div className="box-font">
                {/* For Teachers */}
                {lang === "en"
                  ? "For Teachers"
                  : lang === "hi"
                    ? "शिक्षकों के लिए"
                    : null}
              </div>
              <div>
                <img src={teacher} alt="" width={"85%"} />
              </div>
              <div className="box-para-font text-center">
                {/* It provides structured lesson support, multimedia resources, and
                analytics */}
                {lang === "en"
                  ? "It provides structured lesson support, multimedia resources, and analytics"
                  : lang === "hi"
                    ? "यह संरचित पाठ समर्थन, मल्टीमीडिया संसाधन और विश्लेषण प्रदान करता है।"
                    : null}
              </div>
            </div>

            {/* <div className="p-3 d-flex flex-column align-items-center gap-3 box-katbook">
              <div className="box-font">For Parents</div>
              <div>
                <img src={family} alt="" width={"85%"} />
              </div>
              <div className="box-para-font text-center">
                It offers transparency into their child’s learning journey
              </div>
            </div> */}
          </div>
        </div>

        <div className="hrBase">
          <div className="hrLine" />
        </div>

        <div className="py-3 container">
          <div className="d-flex align-items-center justify-content-center">
            <img src={ueducate} width={"25%"} />
            <span className="HoT">
              {/* About */}
              {lang === "en" ? "About" : lang === "hi" ? "के बारे में" : null}
            </span>{" "}
          </div>

          <div className="row align-items-start h-100 d-flex justify-content-center align-items-center py-5">
            <div className="col-md-6 mb-4 mb-md-0 d-flex justify-content-center">
              <img
                src={aboUeducate}
                className="width_mob abouImgaude"
                alt="Katbook Device Screenshot"
              />
            </div>
            <div className="col-md-6 mb-4 mb-md-0 d-flex flex-column justify-content-center">
              <div className="hot2">
                {/* UEducate Global Private Limited */}
                {lang === "en"
                  ? "UEducate Global Private Limited"
                  : lang === "hi"
                    ? "यूएजुकेट ग्लोबल प्राइवेट लिमिटेड"
                    : null}
              </div>
              <div className="hot3 hsmobipad1">
                {/* A comprehensive digital education platform that seamlessly
                integrates multiple tools for smart education. With its
                innovative and first of its kind product offering, U-Educate is
                revolutionizing teaching and learning, not just in India but
                across the globe. */}
                {lang === "en"
                  ? "A comprehensive digital education platform that seamlessly integrates multiple tools for smart education. With its innovative and first of its kind product offering, UEducate is revolutionizing teaching and learning, not just in India but across the globe."
                  : lang === "hi"
                    ? "एक व्यापक डिजिटल शिक्षा प्लेटफ़ॉर्म जो स्मार्ट शिक्षा के लिए कई उपकरणों को सहजता से एकीकृत करता है। अपने अभिनव और अपनी तरह के पहले उत्पाद के साथ, यू-एजुकेट न केवल भारत में बल्कि पूरे विश्व में शिक्षण और सीखने में क्रांति ला रहा है।"
                    : null}
              </div>
              <div className="hot3 py-3 hsmobipad1">
                {/* By uniting interactive content, adaptive learning systems, and
                real-time analytics empowering educators to personalise
                instruction and students to chart their own learning journeys. */}
                {lang === "en"
                  ? "By uniting interactive content, adaptive learning systems, and real-time analytics empowering educators to personalise instruction and students to chart their own learning journeys."
                  : lang === "hi"
                    ? "इंटरैक्टिव सामग्री, अनुकूली शिक्षण प्रणालियों और वास्तविक समय विश्लेषण को एकीकृत करके शिक्षकों को निर्देश को व्यक्तिगत बनाने और छात्रों को अपनी स्वयं की सीखने की यात्रा तय करने में सक्षम बनाया जा रहा है।"
                    : null}
              </div>
              <div className="py-3 regMobie">
                <button
                  className="registerBtn regReadmore wid200px"
                  onClick={() => {
                    navigate("/ueducate");
                  }}
                >
                  {/* Read more &nbsp; &rarr; */}
                  {lang === "en" ? (
                    <>Read More &nbsp; &rarr;</>
                  ) : lang === "hi" ? (
                    <>और पढ़ें &nbsp; &rarr;</>
                  ) : null}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="hof pb-5">
          <div className="container">
            <div className="py-3 d-flex justify-content-center align-items-center gap-2">
              <div className="d-flex flex-column justify-content-center align-items-center paddd25hof">
                <span className="hof1">
                  {/* Our */}
                  {lang === "en" ? "Our " : lang === "hi" ? "हमारी " : null}
                </span>
                <span className="ourunderline" />
              </div>
              <div className="hof2">
                {/* KATBOOKS */}
                {lang === "en" ? "KATBOOKS" : lang === "hi" ? "कैटबुक्स" : null}
              </div>
            </div>

            <div className="d-flex justify-content-center mb-4">
              <div className="tab-rounded-group">
                {uniqueTabs.map((label, idx) => (
                  <button
                    key={label}
                    className={`tab-btn ${activeTab === label ? "active" : ""
                      } tabfontsze`}
                    style={{
                      borderTopLeftRadius: idx === 0 ? 24 : 0,
                      borderBottomLeftRadius: idx === 0 ? 24 : 0,
                      borderTopRightRadius:
                        idx === uniqueTabs.length - 1 ? 24 : 0,
                      borderBottomRightRadius:
                        idx === uniqueTabs.length - 1 ? 24 : 0,
                      borderRight:
                        idx !== uniqueTabs.length - 1
                          ? "1.2px solid #2970b5"
                          : "none",
                    }}
                    onClick={() => handleTabClick(label)}
                  >
                    {classMap[label] || label}
                  </button>
                ))}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              {showArrows && (
                <div onClick={handlePrevClick}>
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQdSURBVHgBxZrBUtRAEIb/sJvNQnnAgwctS9oncG+WJ+IDWOATQJUnL4JHT2x5sfSy6AvAG8ALWODBM/gCAgc9aJXsyapV1jizmSaTsIEk0wlfVTPsJNmdnp6envSMBzlISajkgSnnLWGOjRwa+WQ+Xzu6kX0lR0qiiqKfHSDuiMYJlexlGnSqZEvJmpIlJQtIWwOmbtHcs4OLHaCfJzQAmQbYjR+YxlVFP7uFBhVaR9xwVmADF3vcBTLfaQ+5FQizaf3AHuo1PyFtoQEE0D1+gMQKa2gOewQcwMH6thLazD0IMK/wg+BIS4HbCcmEUFkZWwmCEH6ns9UOgqhVTBHgojKlYJ8QVaLd7faNEt/Q7VKJRwmJMoV9ZhWJTxCE6MzNLWsltMwEwQuUp4fEZ9avupmQaC7m2F3V+9onjDV+YG7uNqqxjoKdzNPeFoRg52ZrtDudt3BDT/+6jTt5NxCSuZsgBDu3UeK0pG9Mg5AMsXDaDWyNDQjBzn0uvi8S3JCsAPayFwjC1rCd28hvVX0LMuh4wlZJxZYBBH3Ddm6Wlu+/hyzc5tQI4plqEY5ccO5YRkq7e5AlRBLrJlC2woWUc7M1guAD6oGH18IMEs8/hCPauSPPW81U/xvHK4U62DVlqBV5YD7swwHt3IiiaTPeR4xGX1EP3Pk9rUgvU1ka7dzReDx9ah2P36A+TkwZ6j/s6AuoQI5zcwD8rG6ZQX0QLP/m+FGJac59Lu228yx4BTqG8NqruiJ+t7uaq0RsjSaYtN/J7FEULeVe9Lw/aBCtyND8X/o10oszhXmE8P2HaBAnZ1fDaJA7vIJgD/VCMM5uW6RScuFsNHqJ/BgUKod/hPogUx7PWI0gVORsdvZplJeMbrVeoT44mB9qRb6YD9XTPcPhcOx5j5X3D6dcfVLDgpEJTTkJ5gRrLnZBrbXCnKn4HeqB/ZuyFSEcUVF+fYoiv5RV7kOWEFZU5ziybcolOPJ3NNpUMaSfqvS8m+0oeg5ZVky5a1faoV4kw97qdLYzltFpoDuQgXDJqzmnWTYggVpMqsYfZJRxTQUxfVzyah5COsOolvetdE7rJ2Zn78INQoFECe9GyUVkpYzOZ1nKvIYbhZKIhBL51aIof7FTQ99x40bVtBCnTAsl1+38qsieiMaeln3ff4byEJJOXin6EOeMCmlelPMFpvKVbgPbCkwtGz16RTyxSkMbPZrs1htBAjUt65ms4I5VDwJbb5OfRXozVGwCKIDYZqgN+wxPe4T6IKRPVUhl8M9ZRfrIRR+yCvG5FvtQgtiuWRbC9OMWIaoTIu71U+s7d9DgmZSsQkemAWumcZR5Zt7ULZt79POnme/QQ2oR1wAh7s0jlDvalO2ADTg6swc5CMnBs575TNb1oSX7iF9PdXkCAf4DGDy4Nf+5q1cAAAAASUVORK5CYII="
                    style={{
                      width: "75%",
                      cursor:
                        currentPageForActiveTab === 0 ? "no-drop" : "pointer",
                      opacity: currentPageForActiveTab === 0 ? "0.2" : "1",
                    }}
                    alt="leftarrow"
                  />
                </div>
              )}

              <div className="bookrowflex">
                {currentBooks.map((book, idx) => {
                  let Bookencrypted;
                  if (localStorage.getItem("token")) {
                    const xBook =
                      subjectArr?.length > 0 &&
                        subjectArr?.filter((q) => q?.bookId === book?.bookId)
                          ?.length > 0
                        ? subjectArr?.filter(
                          (q) => q?.bookId === book?.bookId
                        )[0]
                        : "";
                    console.log(subjectArr, "BooksText");
                    console.log(book?.bookId, "BooksText");
                    if (xBook && userresidd && UserToken) {
                      const BooksText = `${xBook.path.split('"parentVaribaleId"')[0]
                        }"parentVaribaleId":{"username":"${userresidd}","code":"${UserToken}"}}/${xBook?.standard
                        }/${xBook?.bookId}/789/${xBook?.medium}`;

                      console.log(BooksText, "BooksText");

                      Bookencrypted = CryptoJS.AES.encrypt(
                        JSON.stringify(BooksText),
                        Acckey
                      ).toString();
                    }
                  }
                  return (
                    <div className="card tabimagcard">
                      <img
                        onClick={() => {
                          if (localStorage.getItem("token") && Bookencrypted) {
                            var newOpen = window.open(
                              `${KatbookUrl}/#/auth/book/${Bookencrypted}`
                            );
                            if (
                              newOpen == null ||
                              typeof newOpen == "undefined"
                            ) {
                              alert("Turn off your pop-up blocker!");
                            }
                          }
                        }}
                        src={book.coverImage}
                        className={`card-img-top insiImgcard ${localStorage.getItem("token") && Bookencrypted
                          ? "cursor-pointer"
                          : ""
                          }`}
                        alt={book.bookName}
                      />
                      <div
                        className={`fw-semibold text-center mb-2 cardimgdowtit ${localStorage.getItem("token") && Bookencrypted
                          ? "cursor-pointer"
                          : ""
                          }`}
                        onClick={() => {
                          if (localStorage.getItem("token") && Bookencrypted) {
                            var newOpen = window.open(
                              `${KatbookUrl}/#/auth/book/${Bookencrypted}`
                            );
                            if (
                              newOpen == null ||
                              typeof newOpen == "undefined"
                            ) {
                              alert("Turn off your pop-up blocker!");
                            }
                          }
                        }}
                      >
                        {book.bookName}
                      </div>
                      {!localStorage.getItem("token") && (
                        <div className="card-body d-flex flex-column">
                          <button
                            className="btn btn-primary mt-auto subscribebtn"
                            onClick={() => {
                              setRegisterModal(!registerModal);
                            }}
                          >
                            {/* Subscribe */}
                            {lang === "en"
                              ? "Subscribe"
                              : lang === "hi"
                                ? "सदस्यता लें"
                                : null}
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {showArrows && (
                <div onClick={handleNextClick}>
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQ8SURBVHgBxZq/c9NIFMe/cqxIZo45F1ddk3c3d3Ml7q6M7i8I5V11DA0VE+APwKajImmgDZRUTkuVUFAnNMwwFAkFM9BgZmiIib28tXej1co2svRkPjObHa9Wyn736b39pQByEKeE0xWTt51kOTXp2KTn5vcPRzeyx+mEkyqZ9L07mHbEykk4HXgNGnDa47TNaYvTBrLWgCnbNHX6yHeAvp+wAsg0wG38jmlcWfS9e1ihoFuYNtwK6CLf41Ug80z3lfsfwuw6/+AA9ZqfkLXQDgTQPX6E1ArbWB3uG3CECtZ3RWgzd7B6CGlAKC3GFUHfqxxG0YlOaLcl/QbIi1kK6xOFRGjWWEQzihSnA8hDSMUU9plrSH2Cit6EOCYW834iJgxFHNSjg9Rnbn2vMiFVvrRjr8XxdWMV1Vxf70EeLaBQJ9uwt4dy/MRWeWPFhHEsPg4gnVH051UgpLGbUBJ2+JuOVQZhGEpHO0L6iiWzKlhrdFGNNov4cGEVDgIx+w9ksTOAXGAhCFjDwpa4f2EVI0Y4LOtnWatknruDar6RJY5/YzEfXTE1hGXb5swbZCPVJoRgp3/oCZEOywnSsW4C+QUSRFH0Fzf+c06MbFi2r9dGA6nnH0OQs7Oz15w9y10Igq5gWN43eaKFXDE/DiHMuVJ3ORv75Wo83hUKy7bzO1pIxyuUYzh8pWYFkCBoo9HoC4TltyZP9B/r6Buogyj6PecncmGZ4Pi3HT9qg+dgT+eJqRiWdSdM5l4NrIAAeLTgclIhLH8y+cSqtVtE04zjFwusUmWCOWm/tkhGVW0oNVx4fTxOUAFXyM+oibDV+htzZqqWsVKHWB4y+akrpL7NhdFo8YpOqd7o69cnWB4y+UTIoVcoCk9V/lRBsLWgyu75cHgP5bCD+XGT/7w0P2qxyDlwh6NWa9Y1pdT+aDi8jfIkJp8M5oR0HSwKW+MPjkiDOZHqSGCNYgdz8gsSCMID4ZNZIvTWEapPTxI4o7odEB+bfAtSXLr0a6DUv34x/+fTURD8gy9fTlENO+7su4UXQz2ExhPu+Qc1WUJDWLA0t9ssXVTl8uVf/EXVGu+oQG5HpYcFS/MEZXYYZ8DTkXs5a6yvX4UMhAIbJfY0qsqMVG/SvfOm65LHEYU2EQlL7K/OohFFN7w1evVXNcVumepIRUUra0HLvtMtbvyrmkQQ0k4uPFO2e0aFlFvWWq3/HGtIbv0QShwrWJY66NHr76bxDXbsPuQgVDjo0fhHb7Socpge9BwJbo92IHD0BuQPQ+cGAD3YCQ54gOBhqIv1GRv2CPVByH5VIX76dQ3ZTy56kBVkv2txP0qQHH8yEGZ/bpGgPAmmvT5wntnHCr9J8QWdmAZsm8aRd0/blF01dfT9A+8Z+pXaxA+AMO3NEyz3aZPfAV1UdOYAchDSD8865jc51z856RDT5anO30KAb6R5yQVQB3/2AAAAAElFTkSuQmCC"
                    alt="rightarrow"
                    style={{
                      width: "75%",
                      cursor:
                        currentPageForActiveTab === totalPages - 1
                          ? "no-drop"
                          : "pointer",
                      opacity:
                        currentPageForActiveTab === totalPages - 1
                          ? "0.2"
                          : "1",
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer
        setActiveTab={setActiveTabHeader}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
        selectedLang={selectedLang}
        setSelectedLang={setSelectedLang}
      />
    </div>
  );
};

export default Home;
